import { useMemo, useState } from 'react';

/**
 * Hook for managing state of items collection based on page size, load more button and index to focus on after expanding
 */
export const usePagination = <T>(
  allItems: T[],
  pageSize: number,
): {
  visibleItems: T[];
  hasMore: boolean;
  focusIndex: number | null;
  loadMore: () => void;
} => {
  const [index, setIndex] = useState<number>(pageSize);
  // Do not set focusIndex to 0, because first item will receive focus by default when message focus happens
  const [focusIndex, setFocusIndex] = useState<number | null>(null);
  const hasMore = index < allItems.length;

  return useMemo(
    () => ({
      visibleItems: allItems.slice(0, index),
      hasMore,
      focusIndex,
      loadMore: () => {
        if (hasMore) {
          setFocusIndex(index);
          setIndex(index + pageSize);
        }
      },
    }),
    [allItems, pageSize, hasMore, index, focusIndex],
  );
};
